module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.74bee9f7.jpg";